import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AdminCrm } from "@/components/crm/AdminCrm";

export default function Crm() {
  const { user } = useAuth();
  const [partners, setPartners] = useState([]);
  useEffect(() => { if (user?.role === "admin") api.get("/admin/partners").then((r) => setPartners(r.data)); }, [user]);
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6" data-testid="crm-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-genis">Relation clients</p>
        <h1 className="text-3xl font-extrabold font-heading tracking-tight text-genis-deep dark:text-white">CRM</h1>
        <p className="text-muted-foreground mt-1">Suivez vos clients et prospects, leurs projets, vos échanges et vos relances.</p>
      </div>
      <AdminCrm partners={partners} />
    </div>
  );
}
